import { BIKE_ACTIVE_COLOR, BIKE_MARKER_COLORS } from "../static/bike"
import { BikeState } from "../types/bike"
import { theme } from "../theme"
import { MapBikeEntity } from "../hooks/queries/useGetMapBikesQuery"
import { BIKE_IS_ACTIVE_MINUTES_AGO } from "../config"
import dayjs from "dayjs"

export function getBikeStateColor(state?: BikeState) {
  return theme.colors[BIKE_MARKER_COLORS[state || "unknown"]]["600"] || "blue.600"
}

export function calcAssetState(bike?: MapBikeEntity) {
  if (bike) {
    const minutes_ago = BIKE_IS_ACTIVE_MINUTES_AGO
    const last_cellular_update = dayjs(bike?.last_cellular_update)
    const now = dayjs()
    if (typeof bike?.last_cellular_update !== "undefined") {
      if (now.diff(last_cellular_update, "m") <= minutes_ago) {
        return "active"
      } else {
        if (bike.state) {
          return bike.state
        }
      }
    }
  }
  return "unknown"
}

export function calcBikeStateColor(bike?: MapBikeEntity) {
  if (bike) {
    const minutes_ago = BIKE_IS_ACTIVE_MINUTES_AGO
    const last_cellular_update = dayjs(bike?.last_cellular_update)
    const now = dayjs()
    if (typeof bike?.last_cellular_update !== "undefined") {
      if (now.diff(last_cellular_update, "m") <= minutes_ago) {
        return BIKE_ACTIVE_COLOR
      } else {
        if (bike.state) {
          return getBikeStateColor(bike.state)
        }
      }
    }
  }
  return "unknown.600"
}
